
import store from '../store'

const acl = {

  // módulos não informados pelo backend são considerados habilitados
  moduleEnabled(module) {
    try {
      return store.state.auth.userData.modules[module] !== false
    } catch (e) {
      return true
    }
  },

  // permissões de escrita por módulo: com o módulo desabilitado ele fica somente leitura
  writePermissions: {
    customers: ['customerCreateEdit', 'customerCreditAnalysis'],
    suppliers: ['supplierCreateEdit'],
    products: ['productCreateEdit', 'categoryCreateEdit', 'brandCreateEdit', 'productUpdatePrice'],
    representatives: ['representativeBrandCreateEdit'],
    stock: ['stockAuditCreateEdit', 'stockAuditAddProduct', 'updateStockViaAudit', 'stockTransferCreateEdit', 'stockTransferUpdate', 'stockTransferReceive', 'stockTransferCancel'],
    purchases: ['purchasesCreateEdit', 'purchaseStoreStock', 'purchaseStoreBill', 'purchaseCancel'],
    sales: ['salesCreateEdit'],
    deliveries: ['deliveryCreateEdit', 'deliveryCancel', 'updateToProcessing'],
    finances: ['accountTransactionCreateEdit', 'accountTransactionCancel'],
    bills_payable: ['billPayableCreateEdit', 'billPayableCancel', 'payBillPayable'],
    bills_receivable: ['billReceivableCreateEdit', 'billReceivableCancel', 'payBillReceivable'],
    professionals: ['professionalCreateEdit'],
  },

  isWriteBlocked(permission) {
    return Object.keys(this.writePermissions).some((module) => {
      return !this.moduleEnabled(module) && this.writePermissions[module].includes(permission)
    })
  },

  // module: força o módulo da escrita quando a permissão é compartilhada (ex.: salesCreateEdit em vendas e devoluções)
  can(permission, module = null) {
    if (permission === 'super_admin') {
      return this.isSuperAdmin()
    }

    if (module ? !this.moduleEnabled(module) : this.isWriteBlocked(permission)) {
      return false
    }

    return this.canView(permission)
  },

  // ignora o modo somente leitura: abre detalhes e impressões de módulos desabilitados (sem salvar)
  canView(permission) {
    if (this.isSuperAdmin()) {
      return true
    }

    return this.hasPermission(permission)
  },

  hasPermission(permission) {
    let permissionArr = this.getPermission(permission)

    if (permissionArr) {
      return true
    }

    return false
  },


  getPermission(permission) {
    try {
      return store.state.auth.userData.user.permissions.filter((row) => row.name.trim() == permission.trim())[0]
    } catch (e) {
      return false
    }
  },

  isSuperAdmin() {
    return store.state.auth.userData.user.super_admin == 1
  },


  isSalesman() {
    return store.state.auth.userData.user.position == 'vendedor'

  },

  isManager() {
    return store.state.auth.userData.user.position == 'gerente' || this.isSuperAdmin()
  },

  isCashier() {
    return store.state.auth.userData.user.position == 'caixa'
  },

  isAdministrativeAssistant() {
    return store.state.auth.userData.user.position == 'auxiliar_administrativo'
  },

  isStockman() {
    return store.state.auth.userData.user.position == 'estoquista'
  },

  isBuyer() {
    return store.state.auth.userData.user.position == 'comprador'
  },

  isLogistic() {
    return store.state.auth.userData.user.position == 'logistica'
  }

}

export default acl;